

































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import { screenWidth } from "@/plugins/variables";

@Component({ components: { CustomButton } })
export default class CustomTable extends Vue {
  @Prop() callback: any;
  @Prop() isShowButton!: boolean;
  @Prop() isShowSpinner!: boolean;
  @Prop() isFoundNothing!: boolean;
  @Prop() overflowItems!: boolean;

  get screenWidth() {
    return screenWidth();
  }

  showMore() {
    this.$emit("showMore");
  }
}
